<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        @if(submittedRequests.length === 0) {

        <div class="row">
            <div class="col col-12">
                <h1>defer service account</h1>

                <form class="branded">
                    <fieldset class="pb-4">
                        <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                            <p><strong>service accounts</strong></p>
                        </legend>
                        <p>
                            <b>Service account stewards</b> - A service account must be associated with a service id
                            (CMDB
                            application) and also vaulted
                            in PAS Secret Server to be eligible for service account deferment. Please refer to the <a
                                href="https://go.chevron.com/ServiceAccountQRG">Service Account
                                QRG</a> for more info about how to address these requirements.
                        </p>

                        <p><b>CMDB application owners</b> - Only the owners specified in the CMDB record can submit
                            deferment requests. Please refer to the <a
                                href="https://go.chevron.com/ServiceAccountDeferment">Deferment QRG</a> for more info
                            about the process.</p>

                        @if (!serviceId) {
                        <div class="service-account-search">
                            <div class="col-12 col-md-6 col-lg-6">
                                <mat-form-field appearance="outline" class="w-100"
                                    matTooltip="CMDB Application ID for the application using this app registration"
                                    subscriptSizing="dynamic">
                                    <mat-label>service id</mat-label>
                                    <input (click)="searchForChevronApplication()" matInput [readonly]="true"
                                        formControlName="chevronApp" required>
                                    <button mat-icon-button matSuffix (click)="searchForChevronApplication()">
                                        <mat-icon>search</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </div>
                        }
                        @else {

                        @if(!isRequestorChevronAppOwner) {
                        <p class="service-account-requirements-warning">
                            you are not listed as an owner for {{ chevronApp?.displayName}} ({{serviceId}}).
                            <br>
                            <strong>Note:</strong> only one of the owners {{chevronAppOwnerDisplayNames.length > 0 ? '('
                            + chevronAppOwnerDisplayNames.join(', ') + ') ' : ''}}will be able to submit a
                            deferment for this serviceId
                        </p>
                        }
                        @if(!gettingUsers && usersDataSource.data.length == 0){
                        <div>
                            <display-http-error [message]="errorMessage" [errors]="[]"></display-http-error>
                        </div>}
                        @if(gettingUsers) {
                        <div class="container">
                            <div class="row justify-content-center col-sm-12">
                                <p>searching for service accounts associated with serviceId {{serviceId}}...</p>
                            </div>
                            <div class="row justify-content-center col-sm-12">
                                <p class="text-warning">this may take up to a minute</p>
                            </div>
                            <div class="row justify-content-center col-sm-12">
                                <mat-spinner></mat-spinner>
                            </div>
                        </div> }
                        @if (!gettingUsers && !displaySelectedAccount) {
                        <div class="container">
                            <div>
                                @if (!gettingUsers && usersDataSource.data.length > 0){
                                <filter-input (onKeyUp)="filter($event)"></filter-input>
                                }

                                <table id="users" [hidden]="gettingUsers || usersDataSource.data.length == 0" mat-table
                                    [dataSource]="usersDataSource" matSort matSortActive="displayName"
                                    matSortDirection="asc" aria-describedby="users you have access to">
                                    <caption>service accounts that can be deferred</caption>

                                    @for (disCol of selectedDisplayCols; track disCol; let colIndex = $index) {
                                    <ng-container matColumnDef="{{disCol}}">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{disCol | convertDisplayLabels}}
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            @if (isArrayWithElements(element[disCol])) {
                                            <ng-container>
                                                @for(item of element[disCol]; track item){
                                                <div><text-formatter [content]="item"></text-formatter></div>
                                                }
                                            </ng-container>
                                            }
                                            @else {
                                            <ng-container>
                                                <text-formatter [content]="element[disCol]"></text-formatter>
                                            </ng-container>
                                            }
                                        </td>
                                    </ng-container>
                                    }
                                    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="selectRow(row)"
                                        class="service-account-row"></tr>
                                </table>
                                <mat-paginator [hidden]="gettingUsers || usersDataSource.data.length == 0"
                                    [length]="usersDataSource.data.length" [pageSizeOptions]="[10, 20, 30, 40]"
                                    showFirstLastButtons></mat-paginator>
                                @if(serviceAccountSelectErrorMessage) {
                                <mat-error style="text-align: center; margin: 20px 20px;"
                                    [innerHTML]="serviceAccountSelectErrorMessage"></mat-error>
                                }
                            </div>
                        </div>
                        }
                        @else if(!gettingUsers){
                        <display-form [displayObject]="displaySelectedAccount" [includeRefreshButton]="true"
                            (refreshClicked)="resetSelectedAccount()" />
                        <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white justification-legend">
                            <p><strong>justification</strong></p>
                        </legend>
                        <div class="row">
                            <div class="col-12">
                                <mat-form-field appearance="outline" class="w-100"
                                    matTooltip="Justification for permissions request" subscriptSizing="dynamic">
                                    <mat-label>justification</mat-label>
                                    <input matInput [formControl]="justification">
                                    <mat-error>Justification is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        }
                        }


                    </fieldset>

                    <mat-divider></mat-divider>

                    <display-http-error [message]="submitErrorMessage.message"
                        [errors]="submitErrorMessage.errors"></display-http-error>
                    @if(!gettingUsers) {
                    <div class="btn-toolbar d-flex justify-content-center pt-4 pb-4" role="toolbar">
                        @if(isSubmitting) {
                        <mat-spinner [diameter]="30" class="mat-spinner-search"></mat-spinner>}
                        @else {
                        @if(selectedAccount && submittedRequests.length == 0) {
                        <div class="btn-group mr-2" role="group">
                            <button [disabled]="!isRequestorChevronAppOwner" class="button" type="submit"
                                (click)="onSubmit()">submit</button>
                        </div>
                        }
                        @if(serviceId != undefined){
                        <div class="btn-group mr-2" role="group">
                            <button class="button" type="reset" (click)="resetForm()">reset</button>
                        </div>
                        }
                        }
                    </div>}
                </form>
            </div>
        </div> }
        @if(submittedRequests.length > 0) {
        <div class="row">
            <div class="col col-12">
                <a class="close-button" (click)="resetSelectedAccount()"><span
                        class="icon-remove close-button"></span></a>
                <h1>request submitted</h1>
                <display-http-error [message]="submitErrorMessage.message"
                    [errors]="submitErrorMessage.errors"></display-http-error>
                <display-requests [requests]="submittedRequests"></display-requests>
            </div>
        </div>}
    </section>
</main>